/* 
 * React component to display a patient record
 */

import {OKCancel}                              from '../../lib/iprs-react-library/src/index.js';
import  {B_ACTIONS}                            from '../Booking/bookingReducer'

const Patient = ({patientRecord}) => {
    
    return (
        <>
        <dl>
            <dt>Client Name</dt>
            <dd>{patientRecord.patient.clientName}</dd>
            <dt>Referral Date</dt>
            <dd>{patientRecord.patient.referralDate}</dd>
            <dt>Case Reference</dt>
            <dd>{patientRecord.patient.caseID}</dd>
        </dl>
        
        <h2>Patient</h2>
        <dl>
            <dt>First Name</dt>
            <dd>{patientRecord.patient.firstName}</dd>
            <dt>Last Name</dt>
            <dd>{patientRecord.patient.lastName}</dd>
            <dt>Date of Birth</dt>
            <dd>{patientRecord.patient.birthDate}</dd>
            
            <dt>Address</dt><dd>
                { patientRecord.patient.hasAddress()? 
                    <Address address={patientRecord.patient.getAddress()} />: 
                    'No address recorded' }
            </dd>
        </dl>
        </>
    )
}

const Address = ({address}) => {
    
    return <>
        {address.line1? <>{address.line1}<br/></>: ''}
        {address.line2? <>{address.line2}<br/></>: ''}
        {address.town? <>{address.town}<br/></>: ''}
        {address.county? <>{address.county}<br/></>: ''}
        {address.postcode? <>{address.postcode}<br/></>: ''}
        {address.country? <>{address.country}<br/></>: ''}
    </>
}

const PatientConfirm = ({patientRecord, bookingDispatch, text}) => {

    const handleOK = () => {
        bookingDispatch( B_ACTIONS.PATIENT_CONFIRM )
    }

    const handleCancel= () => {
        bookingDispatch( B_ACTIONS.CANCEL )
    }

    return <>
        <Patient              patientRecord={patientRecord} />
        <OKCancel onOK={handleOK} onCancel={handleCancel}  okText={text}       />
    </>
}

export {PatientConfirm}
export default Patient
